import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Button, Icon, Sidebar, Input } from 'semantic-ui-react';
import i18next from 'i18next';

import { DataGrid } from '../../common';
import SideEditor from '../../general/SideEditor';
import DashboardUserEditor from './DashboardUserEditor';
import { getDashboardUsers } from '../../../selectors';
import { fetchDashboardUsers, setEditedEntity, confirmDelete, deleteDashboardUser } from '../../../actions';

class DashboardUsers extends Component {

    constructor(props) {
        super(props);

        this.renderCreationButton = this.renderCreationButton.bind(this);
    }

    componentWillMount() {
        this.props.fetchDashboardUsers();
    }

    handleDelete = (user) => {
        this.props.confirmDelete(user.email, () => this.props.deleteDashboardUser(user.id));
    }

    renderCreationButton() {
        const { setEditedEntity } = this.props;

        return (
            <Button
                icon
                labelPosition='left'
                floated="right"
                primary
                onClick={() => setEditedEntity('panelUser')}
            >
                <Icon name='add' /> {i18next.t('create')}
            </Button>
        );
    }

    render() {
        const { dashboardUsers, onEdit, setEditedEntity } = this.props;

        const columns = [{
            Header: '#',
            accessor: 'id',
            maxWidth: 50,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' }
        }, {
            Header: i18next.t('email'),
            accessor: 'email',
            maxWidth: 220,
            filterable: true
        }, {
            id: 'restaurant',
            Header: i18next.t('restaurant'),
            accessor: user => user.permittedRestaurants,
            filterable: true
        }, {
            id: 'company',
            Header: i18next.t('company'),
            accessor: user => user.permittedCompanies,
            filterable: true
        }, {
            id: 'loyalty',
            Header: i18next.t('loyalty'),
            accessor: user => user.permittedLoyaltyPrograms,
            filterable: true
        }, {
            id: 'actions',
            Header: i18next.t('actions'),
            maxWidth: 142,
            sortable: false,
            filterable: false,
            Cell: row => {
                const user = row.original;

                return (
                    <div>
                        <Button circular size='tiny' icon='write' basic onClick={() => setEditedEntity('panelUser', user)} />
                        <Button circular size='tiny' icon='trash' negative onClick={() => this.handleDelete(user)} />
                    </div>
                );
            }
        }];

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('panelUser')}
                    visible={onEdit}
                    handleClose={() => setEditedEntity(null)}
                >
                    <DashboardUserEditor />
                </SideEditor>

                <DataGrid
                    data={dashboardUsers}
                    columns={columns}
                    getTrGroupProps={(state, rowInfo, column) => {
                        return {};
                    }}
                    extraActions={this.renderCreationButton()}
                    paginated
                   
                />

            </div>
        );
    }
}

DashboardUsers.propTypes = {
    fetchDashboardUsers: PropTypes.func,
    dashboardUsers: PropTypes.array,
    chains: PropTypes.array,
    onEdit: PropTypes.bool,
    setEditedEntity: PropTypes.func,
    confirmDelete: PropTypes.func,
    deleteDashboardUser: PropTypes.func,
    history: PropTypes.object,
    
};

const mapStateToProps = (state, ownProps) => {
    const { chains } = state.businessApp;
    const onEdit = state.editor.type === 'panelUser';
    const dashboardUsers = getDashboardUsers(state);

    return { dashboardUsers, chains, onEdit };
};

export default connect(mapStateToProps,
    { fetchDashboardUsers, setEditedEntity, confirmDelete, deleteDashboardUser })(DashboardUsers);
